import { CONFIGURATION, DEFAULT_LANG, LOCALJSON, LS_LANG, OPTIONAL_LANG} from './constants';
import * as _ from 'lodash';
import { timeout } from 'rxjs/operators';

export class Utils {
  /**
  * @description
  * Comprueba si estamos en la configuración que apunta a los json locales
  * @returns True: Configuración actual con json locales
  */
  public static isLocaljson(): boolean {
    return CONFIGURATION === LOCALJSON;
  }

  /**
  * @description
  * Devuelve si un dato está definido y no es nulo.
  * En caso de también pasar un valor se compara si es igual o distinto al dato
  * @param data True si un dato está definido y no es nulo
  * @param val Valor a comparar. En caso de no pasar nada no se compara
  * @param equa True si se compara si es igual (==), false si se compara si son distintos (!=). Por defecto false.
  * @returns True: Objeto no undefined ni nulo (y si la comparación solicitada también es cierto)
  */
  public static noUndfAndNull(data: any, val?: any, equa: boolean = false) {
    let noUndfAndNull = data != undefined && data != null;
    if (val != undefined && val != null) {
      switch (equa) {
        case true: return noUndfAndNull && val == data;
        default: return noUndfAndNull && val != data;
      }
    }
    return noUndfAndNull;
  }

  /**
  * @description
  * Compara dos tipos (number, boolean o string) sin tener en cuenta su tipo.
  * <p>
  * En la comparación se estima que undefined, null o string vacío es lo mismo.
  *
  * @param obj1 - Primer parámetro
  * @param obj2 - Segundo parámetro
  * @returns {boolean} <ul><li>True: Iguales</li><li>False: Distintos</li></ul>
  */
  public static compareTextOrNumber(obj1: any, obj2: any): boolean {
    var text1 = obj1 == undefined || obj1 === null || obj1 === "" ? null : obj1 + "";
    var text2 = obj2 == undefined || obj2 === null || obj2 === "" ? null : obj2 + "";

    return text1 === text2;
  }


  /**
  * @description
  * Compara dos Arrays
  *
  * @param obj1 - Primer Array
  * @param obj2 - Segundo Array
  * @returns {boolean} <ul><li>True: Iguales</li><li>False: Distintos</li></ul>
  */
  public static compareArrays(obj1: any, obj2: any): boolean {
    for(let i = 0; i < obj1.length; i++){
      for(let j = 0; j < obj1.length; j++){
          return obj1[i].value === obj2[j].value;
      }
    }
  }


  /**
  * @description
  * Mueve de posición un ítem en un array
  * @param arr Array
  * @param old_index Posición actual del ítem
  * @param new_index Posición a la que se quiere mover un ítem
  * @returns Array resultante
  */
  public static move(arr, old_index, new_index) {
    while (old_index < 0) {
      old_index += arr.length;
    }
    while (new_index < 0) {
      new_index += arr.length;
    }
    if (new_index >= arr.length) {
      var k = new_index - arr.length;
      while ((k--) + 1) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  }

  /**
  * Accede al DOM y habilita/deshabilita todos los botones y enlaces
  * @param value True: hidden a true y tabindex a -1, False: hidden a false
  */
  public static toggleAllButtonsAndHref(value: boolean | null = null) {
    let buttons = document.getElementsByTagName('button');
    for(var i = 0; i < buttons.length; i++) {
      let attrAH = buttons[i].getAttribute('aria-hidden');
      let attrTI = buttons[i].getAttribute('tabindex');
      if (!this.noUndfAndNull(value)) {
        buttons[i].setAttribute('aria-hidden', attrAH == 'true' ? 'false' : 'true' );
        buttons[i].setAttribute('tabindex', attrTI == '-1' ? '' : '-1');
      } else {
        buttons[i].setAttribute('aria-hidden', value + "");
        buttons[i].setAttribute('tabindex', value ? '-1' : '');
      }
    }
    let as = document.getElementsByTagName('a');
    for(var i = 0; i < as.length; i++) {
      let attrAH = as[i].getAttribute('aria-hidden');
      let attrTI = as[i].getAttribute('tabindex');
      if (!this.noUndfAndNull(value)) {
        as[i].setAttribute('aria-hidden', attrAH == 'true' ? 'false' : 'true');
        as[i].setAttribute('tabindex', attrTI == '-1' ? '' : '-1');
      } else {
        as[i].setAttribute('aria-hidden', value + "");
        as[i].setAttribute('tabindex', value ? '-1' : '');
      }
    }
  }

  /**
  * Pone tabindex a -1 en los dos div que crea automáticamente el dialog de Material con la clase cdk-focus-trap-anchor
  */
  public static accessibilityDialogCdk() {
    setTimeout( () => {
      let cdks = document.getElementsByClassName('cdk-focus-trap-anchor');
      for(var i = 0; i < cdks.length; i++) {
        cdks[i].setAttribute('tabindex', '-1');
      }
    }, 500);
  }

  /**
  * Nos dice si el Nº de identificacion es un CIF o no
  * @param nif Nº de identificacion
  */
  public static isCifEmpresa(nif: string): boolean {
    if (!nif || nif.length !== 9) {
      return false;
    }

    let letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
	  let digits = nif.substr(1, nif.length - 2);
	  let letter = nif.substr(0, 1);
	  let control = nif.substr(nif.length - 1);
	  let sum = 0;
    let digit: number;
    
    if (!letter.match(/[A-Z]/)) {
      return false;
    }

    for (let i = 0; i < digits.length; ++i) {
      digit = parseInt(digits[i]);
  
      if (isNaN(digit)) {
        return false;
      }
  
      if (i % 2 === 0) {
        digit *= 2;
        if (digit > 9) {
          digit = digit / 10 + (digit % 10);
        }
        sum += digit;
      } else {
        sum += digit;
      }
    }

    sum %= 10;
	  if (sum !== 0) {
		  digit = 10 - sum;
	  } else {
		  digit = sum;
	  }

	  if (letter.match(/[ABEH]/)) {
		  return String(digit) === control;
	  }
	  if (letter.match(/[NPQRSW]/)) {
		  return letters[digit] === control;
	  }

    return String(digit) === control || letters[digit] === control;
  }


  public static isCifEmpresa2(nif: string): boolean {
    var pares = 0;
    var impares = 0;
    var suma;
    var ultima;
    var unumero;
    let uletra = new Array('J' , 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I') ;
    var xxx;
    ultima = nif.substr( 8,1 );

    for (var cont = 1 ; cont < 7 ; cont ++){
      xxx = (2 * parseInt(nif.substr(cont++,1))).toString() + '0';
      impares += parseInt(xxx.substr( 0,1 )) + parseInt(xxx.substr( 1,1 ));
      pares += parseInt(nif.substr(cont,1));
    }

    xxx = (2 * parseInt(nif.substr(cont,1))).toString() + '0';
    impares += parseInt(xxx.substr( 0,1 )) + parseInt(xxx.substr( 1,1 ));
    suma = (pares + impares).toString();
    unumero = parseInt(suma.substr(suma.length - 1, 1));
    unumero = (10 - unumero).toString();
    if(unumero == 10) unumero = 0;
    return unumero;
  }


  public static isCifEmpresa3(nif: string): boolean {

    var resul = false;
    var temp = nif.toUpperCase(); 

    if (!/^[A-Za-z0-9]{9}$/.test(temp))
      resul = false;
    else if (!/^[ABCDEFGHKLMNPQS]/.test(temp)) // Es una letra de las admitidas ?
      resul = false;
    else 
      resul = true;

    var v1 = new Array(0,2,4,6,8,1,3,5,7,9); 
    var temp1 = 0; 

    if(resul){
      for( let i = 2; i <= 6; i += 2 ) {
          temp = temp + v1[ parseInt(nif.substr(i-1,1)) ];
          temp = temp + parseInt(nif.substr(i,1));
      }

      temp1 = temp1 + v1[ parseInt(nif.substr(7,1)) ];
      temp1 = (10 - (temp1 % 10));

      return true;
    }else{
      return false
    }
  }

  public static validateDNI(dni: string): boolean {
    var numero: any;
    var letraAux: string; 
    var letra : string;
    var expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;

    dni = dni.toUpperCase();

    if(expresion_regular_dni.test(dni) === true){
        numero = dni.substr(0,dni.length-1);
        numero = numero.replace('X', 0);
        numero = numero.replace('Y', 1);
        numero = numero.replace('Z', 2);
        letraAux = dni.substr(dni.length-1, 1);
        numero = numero % 23;
        letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
        letra = letra.substring(numero, numero+1);
        if (letra != letraAux) {
            return false;
        }else{
            return true;
        }
    }else{
        return false;
    }
  }

  public static validateDNI2(value: string): boolean {
    var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
    var nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
    var nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
    var str = value.toString().toUpperCase();

    var pass = /^[a-z]{3}[0-9]{6}[a-z]?$/i;
    var resulpass = pass.test(value);

    var dniresult : boolean = false;
  
    if (!nifRexp.test(str) && !nieRexp.test(str) && !resulpass) return false;
  
    if (nifRexp.test(str) && nieRexp.test(str)){
      var nie = str
      .replace(/^[X]/, '0')
      .replace(/^[Y]/, '1')
      .replace(/^[Z]/, '2');
  
      var letter = str.substr(-1);
      var charIndex = parseInt(nie.substr(0, 8)) % 23;
      dniresult = (validChars.charAt(charIndex) === letter);
    }
  
    if (dniresult || (resulpass)) return true;
  
    return false;
  }

  public static validateDNI3(documento: string): boolean {
      // Expresión regular para validar el formato del NIF o NIE
    var regexNIF = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i;
    var regexNIE = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/i;

    if (!regexNIF.test(documento) && !regexNIE.test(documento)) {
        return false; // El formato del documento es incorrecto
    }

    var letrasNIF = 'TRWAGMYFPDXBNJZSQVHLCKE';
    var letrasNIE = 'XYZ';
    var numero;
    var letra;

    if (documento.length === 9) {
        // Es un NIE
        var letraInicial = documento.charAt(0);
        if (letraInicial === 'X') {
            numero = parseInt('0' + documento.substr(1, 8), 10);
        } else if (letraInicial === 'Y') {
            numero = parseInt('1' + documento.substr(1, 8), 10);
        } else if (letraInicial === 'Z') {
            numero = parseInt('2' + documento.substr(1, 8), 10);
        }
        letra = documento.slice(-1).toUpperCase();
    } else {
        // Es un NIF
        numero = parseInt(documento.slice(0, -1), 10);
        letra = documento.slice(-1).toUpperCase();
    }

    var indice;
    if (documento.length === 9) {
        // Cálculo del índice para NIE
        indice = numero % 23;
        // Para los NIE, la letra de control se selecciona de un conjunto diferente
        letra = letrasNIE.charAt(indice);
    } else {
        // Cálculo del índice para NIF
        indice = numero % 23;
    }

    // Comprobar si la letra coincide con la calculada
    if (letra === letra.toUpperCase()) {
        return true; // El documento es válido
    } else {
        return false; // El documento es incorrecto
    }
  }

  public static isNifCifJuridico(nif: string): boolean {
    nif = nif.toUpperCase();

    const regexCIF = /^[A-HJ-NP-T]{1}\d{8}[A-J]{1}$/;  // Para CIFs (letra + 8 números + letra de control)
    const regexNIFJuridico = /^[A-HJ-NP-TQ]{1}\d{7}[A-J]{1}$/;  // Para NIF con personalidad jurídica (incluyendo Q)

    return regexCIF.test(nif) || regexNIFJuridico.test(nif);
  }

  /**
  * @description
  * Cambiar traducción ca/es según selección usuario (cabezera paginas).
  */
  public static changeStyleTranslate(){
    switch (localStorage.getItem(LS_LANG)) {
      case DEFAULT_LANG: {
        document.getElementById("catalan").classList.add('active');
        document.getElementById("castellano").classList.remove('active');
        break;
      }
      case OPTIONAL_LANG: {
        document.getElementById("catalan").classList.remove('active');
        document.getElementById("castellano").classList.add('active');
        break;
      }
      default: {
        document.getElementById("catalan").classList.add('active');
        document.getElementById("castellano").classList.remove('active');
      }
    }
  }

  public static validaCif(control: string): boolean { 

    var texto = control;
    var pares = 0; 
    var impares = 0; 
    var suma; 
    var ultima; 
    var unumero; 
    var uletra = new Array("J", "A", "B", "C", "D", "E", "F", "G", "H", "I"); 
    var xxx; 
         
    texto = texto.toUpperCase();   
    var regular = new RegExp(/^[ABCDEFGHKLMNPQS]\d\d\d\d\d\d\d[0-9,A-J]$/g); 

    var pass = /^[a-z]{3}[0-9]{6}[a-z]?$/i;
    var resulpass = pass.test(control);

    if (!regular.exec(texto) && (!resulpass)){
      return false;
		}
		 
    ultima = texto.substr(8,1); 
 
    for (var cont = 1 ; cont < 7 ; cont ++){ 
      xxx = (2 * parseInt(texto.substr(cont++,1))).toString() + "0"; 
      impares += parseInt(xxx.substr(0,1)) + parseInt(xxx.substr(1,1)); 
      pares += parseInt(texto.substr(cont,1)); 
    } 
    xxx = (2 * parseInt(texto.substr(cont,1))).toString() + "0"; 
    impares += parseInt(xxx.substr(0,1)) + parseInt(xxx.substr(1,1)); 
          
    suma = (pares + impares).toString(); 
    unumero = parseInt(suma.substr(suma.length - 1, 1)); 
    unumero = (10 - unumero).toString(); 

    if(unumero == 10) unumero = 0;   
      if ((ultima == unumero) || (ultima == uletra[unumero])) 
        return true; 
      else{
        return false;
			}
    }

    /**
    * @description
    * Crear una fecha con formato especifico.
    */
    public static formatofecha(): string { 
      let fecha = new Date();

      let formatomes = ("0" + (fecha.getMonth() + 1)).slice(-2).toString();
      let formatodia = ("0" + fecha.getDate()).slice(-2).toString();
      let formatohora = ("0" + fecha.getHours()).slice(-2).toString();
      let formatominu = ("0" + fecha.getMinutes()).slice(-2).toString();
      let formatoseco = ("0" + fecha.getSeconds()).slice(-2).toString();

      let formato = fecha.getFullYear().toLocaleString() + formatomes + formatodia + formatohora + formatominu + formatoseco;

      return formato;
    }

    /**
    * @description
    * Modificar un string poniento todas las primeras letras de cada palabra en mayúscula y juntarlo.
    */
    public static formatoFirstCase(texto: string): string { 

      const words = texto.split(" ");
      let nombre = "";

      for (let i = 0; i < words.length; i++) {
          words[i] = words[i][0].toUpperCase() + words[i].substr(1);
          nombre = nombre.concat(words[i]);
      }

      return nombre;
    }

    public static replaceAccentedVowels(input: string): string {
      const replacements: { [key: string]: string } = {
        'á': 'a',
        'é': 'e',
        'í': 'i',
        'ó': 'o',
        'ú': 'u',
        'Á': 'A',
        'É': 'E',
        'Í': 'I',
        'Ó': 'O',
        'Ú': 'U',
        'ä': 'a',
        'ë': 'e',
        'ï': 'i',
        'ö': 'o',
        'ü': 'u',
        'Ä': 'A',
        'Ë': 'E',
        'Ï': 'I',
        'Ö': 'O',
        'Ü': 'U',
        'à': 'a',
        'è': 'e',
        'ì': 'i',
        'ò': 'o',
        'ù': 'u',
        'À': 'A',
        'È': 'E',
        'Ì': 'I',
        'Ò': 'O',
        'Ù': 'U'
      };
    
      return input.replace(/[áéíóúÁÉÍÓÚäëïöüÄËÏÖÜàèìòùÀÈÌÒÙ]/g, match => replacements[match]);
    }

    public static obtenerTipoCertificado(COMPANYID: string, CERTIFICATTYPE: string): "F" | "J" {
    
      if (COMPANYID === "0") {
          return "F";
      }

      if (CERTIFICATTYPE === "0") {
          return "F";
      }

      const descUpper = this.replaceAccentedVowels(CERTIFICATTYPE).toUpperCase();
      if (descUpper.includes("FISICA REPRESENTANTE")) {
          return "J";
      }

      if (descUpper.includes("JURIDICA")) {
          return "J";
      }
      return "F";
    }

    public static obtenerTipoCertificadoValido(CERTIFICATTYPE: string): "F" | "J" {
      if (CERTIFICATTYPE === "11" || CERTIFICATTYPE === "12") {
        return "J";
      }
      return "F";
    }

}
